export const extractInitials = (name: string | null | undefined): string => {
  if (!name?.trim()) {
    return 'NA';
  }

  if (name.trim()[0] === '+') {
    return name;
  }
  const splitName = name.trim().split(' ');
  if (splitName.length === 1) {
    return splitName[0][0].toUpperCase();
  }
  return (
    splitName[0][0].toUpperCase() +
    splitName[splitName.length - 1][0].toUpperCase()
  );
};
